import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CreateEvaluationTestDialog } from './CreateEvaluationTestDialog';

export const EditEvaluationTestPage = () => {
  const navigate = useNavigate();
  const { testId } = useParams<{ testId: string }>();
  const [isDialogOpen] = useState(true);

  const handleClose = () => {
    navigate('/opinions/evaluation');
  };

  const handleSuccess = () => {
    navigate('/opinions/evaluation');
  };

  if (!testId) {
    navigate('/opinions/evaluation');
    return null;
  }

  return (
    <CreateEvaluationTestDialog
      isOpen={isDialogOpen}
      onClose={handleClose}
      onSuccess={handleSuccess}
      testId={testId}
      mode="edit"
    />
  );
};
